// eslint-disable-next-line no-restricted-imports -- Required for Node.js script compatibility (routesMetadata.config.js)
import { TABLE_COLUMN_DEFINITIONS, TABLE_COL_NAMES } from './table-cell.const.js'

export const APPROVAL_STATUS = {
  active: 'active',
  inactive: 'inactive',
}

export const APPROVAL_FILTER_FIELDS = {
  search: '', // string
  dateCreatedRange: null, // '1d', '1w', '1m', '3m', 'all'
  lastApprovedRange: null, // '1d', '1w', '1m', '3m', '1y'
  status: APPROVAL_STATUS.active, // 'active', 'inactive'
}

export const APPROVAL_SORT_PAGINATION_FIELDS = {
  sortBy: TABLE_COL_NAMES.DATE_CREATED,
  descending: true,
  page: 1,
  rowsPerPage: 15,
}

export const DEFAULT_FILTER_SORT = {
  ...APPROVAL_SORT_PAGINATION_FIELDS,
  ...APPROVAL_FILTER_FIELDS,
}

// Base columns that are always shown
export const APPROVAL_TABLE_BASE_COLUMNS = [
  TABLE_COLUMN_DEFINITIONS.productName,
  TABLE_COLUMN_DEFINITIONS.lastUserConfirmation,
  TABLE_COLUMN_DEFINITIONS.dateCreated,
]

export const CREATED_DATE_RANGE_OPTIONS = [
  { label: 'All time', value: null },
  { label: 'Last Day', value: '1d' },
  { label: 'Last Week', value: '1w' },
  { label: 'Last Month', value: '1m' },
  { label: 'Last 3 Months', value: '3m' },
]

export const EXPIRY_DATE_RANGE_OPTIONS = [
  { label: 'All time', value: null },
  { label: 'Last Day', value: '1d' },
  { label: 'Last Week', value: '1w' },
  { label: 'Last Month', value: '1m' },
  { label: 'Last 3 Months', value: '3m' },
  { label: 'Last Year', value: '1y' },
]

export const APPROVAL_DIRECTORIES = [
  { id: APPROVAL_STATUS.active, label: 'Active', icon: 'badge-check' },
  { id: APPROVAL_STATUS.inactive, label: 'Revoked', icon: 'badge-x' },
]
